<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت ثبت استعلام های سامانه ستاد</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">لیست استعلام های در حال ثبت</h5>
                                <!--<h5 class="text-accent-light" v-if="showReciveDate">(سر رسید تاریخ)</h5>-->

                                <h5 class="text-accent-light" v-if="showArchive">(آرشیو شده)</h5>
                                <div class="text-left">
                                    <button class="btn btn-link text-accent-lightt"
                                            @click="onMyRegistrationRecordClicked()">
                                        <i class="fa fa-eye" v-if="showMyRegister" title="نمایش تمام استعلام ها"></i>
                                        <i class="fa fa-eye-slash" v-else title="نمایش استعلام های خودم"></i>
                                    </button>

                                    <button class="btn btn-link text-accent-lightt"
                                            @click="onArchiveClicked()">
                                        <i class="fa fa-eye" v-if="showArchive" title="عدم نمایش آرشیو ها"></i>
                                        <i class="fa fa-eye-slash" v-else title="نمایش آرشیو ها"></i>
                                    </button>
                                    <button class="btn btn-link text-accent-light"
                                            @click="onAddInquiriClicked()"><i class="fa fa-plus"></i>
                                    </button>
                                </div>

                            </div>

                            <div class="col-12 input-group round mb-3" v-if="!showArchive">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از نام سازمان/مشتری را وارد کنید">
                            </div>
                            <!--///////// FILTERS  /////////////////-->


                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="inquirisList.length===0">
                                        <p class="text-center mt-3">هیچ نیاز/استعلامی ثبت نشده است. برای ثبت روی دکمه +
                                            کلیک
                                            کنید</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr>
                                                <th>شماره نیاز</th>
                                                <th>تاریخ نیاز</th>
                                                <th>نام مشتری</th>

                                                <th>وضعیت استعلام</th>
                                                <th>تاریخ اتمام</th>
                                                <th>ساعت اتمام</th>
                                                <th class="text-center">عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="it in inquirisList" v-if="inquirisList.length>0">
                                                <td class="text-nowrap">{{it.inquirynumber}}</td>
                                                <td class="text-nowrap">{{showDateDayWork(it.startDate)}}</td>
                                                <td class="text-wrap">{{it.customerFullName}}</td>
                                                <td class="text-nowrap">{{showstatusinquiry(it.inquiryStatus)}}</td>
                                                <td class="text-nowrap">{{showDateDayWork(it.expiryDate)}}</td>
                                                <td class="text-nowrap">{{showExpiryHour(it.expiryHour)}}</td>

                                                <td class="text-center text-nowrap"><i
                                                        class="fa fa-pencil-square-o px-3 clickable"
                                                        style="font-size: larger"
                                                        @click="editInquiryItem(it)"
                                                        title="ویرایش آیتم"></i>
                                                    | <i class="fa fa-trash-o px-3 clickable"
                                                         style="font-size: larger"
                                                         @click="deleteInquiryItem(it)"
                                                         title="حذف آیتم"></i>
                                                </td>

                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="inquiriMode=== 'create'">ثبت استعلام جدید</h1>
                        <h1 v-else> ویرایش استعلام</h1>
                    </div>


                    <div class="row mt-2">
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">شماره نیاز</span>
                                </div>
                                <input class="form-control" v-model="inquiriModel.inquirynumber">
                            </div>
                        </div>
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ نیاز</span>
                                </div>
                                <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateInquiryDatePicked"
                                             :auto-submit="true"
                                             ref="inquirydate" style="flex: 1">
                                    <slot>
                                        <input v-model="inquirydate"
                                               class="form-control date-input flex-grow-1" readonly="true"
                                               @click="toggleCreateInquiryDatePicker">
                                    </slot>
                                </date-picker>
                            </div>
                        </div>

                        <div class="col-lg-6 mb-2">
                            <div class="input-group round">

                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام مشتری/سازمان</span>

                                </div>
                                <vs-select @onSearch="onDropDownFocused"
                                           @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="customers2"
                                           :mode="'create'"
                                           :selected-val="filtercustomer"
                                           :header="{multiple: false, label: 'fullName'}"
                                           aria-placeholder=""
                                           @onChange="onfiltercustomerInquiryChange"></vs-select>

                            </div>

                        </div>

                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ شروع</span>
                                </div>
                                <date-picker type="date" format="jYYYY/jMM/jDD" @input="onStartDatePicked"
                                             :auto-submit="true"
                                             ref="inquiryStartdate" style="flex: 1">
                                    <slot>
                                        <input v-model="inquiryStartdate"
                                               class="form-control date-input flex-grow-1" readonly="true"
                                               @click="toggleStartDatePicker">
                                    </slot>
                                </date-picker>
                            </div>
                        </div>

                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">ساعت شروع</span>
                                    <input type="number" class="form-control" v-model="inquiriModel.startHour"
                                       @input="onChangestartHour">
                                </div>
                            </div>
                            <small class="text-center">{{this.displaystartHour}}</small>
                        </div>

                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ اتمام</span>
                                </div>
                                <date-picker type="date" format="jYYYY/jMM/jDD" @input="onEndDatePicked"
                                             :auto-submit="true"
                                             ref="inquiryEnddate" style="flex: 1">
                                    <slot>
                                        <input v-model="inquiryEnddate"
                                               class="form-control date-input flex-grow-1" readonly="true"
                                               @click="toggleEndDatePicker">
                                    </slot>
                                </date-picker>
                            </div>
                        </div>

                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">ساعت اتمام</span>
                                </div>
                                <input type="number" class="form-control" v-model="inquiriModel.expiryHour"
                                       @input="onChangeexpiryHour">
                            </div>
                            <small class="text-center">{{this.displayexpiryHour}}</small>
                        </div>

                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نوع نیاز</span>
                                </div>
                                <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="eninquiriType"
                                           :mode="'create'"
                                           :selected-val="selectedinquiriType"
                                           :header="{multiple: false, label: 'title'}"
                                           aria-placeholder="نوع نیاز"
                                           @onChange="onInquiriTypeChange"></vs-select>
                            </div>
                        </div>

                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">مدت تسویه</span>
                                </div>
                                <input type="number" class="form-control" v-model="inquiriModel.settlementPeriod"
                                       @input="onChangesettlement">
                            </div>
                        </div>

                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">مبلغ ضمانت نامه</span>
                                </div>
                                <input type="number" class="form-control" v-model="inquiriModel.guaranteeAmount">
                            </div>
                        </div>
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">وزن تقریبی کالاها</span>
                                </div>
                                <input type="number" class="form-control" v-model="inquiriModel.productWeight">
                            </div>
                        </div>

                    </div>
                    <hr class="w-100"/>
                    <div class="row w-100">
                        <h4 class="col-12 text-center">انتخاب کالا های استعلام</h4>
                        <div class="row mt-3">
                            <div class="col-lg-6 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام کالا/خدمات</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="products"
                                               :mode="'create'"
                                               :selected-val="selectedinquiryproduct"
                                               :header="{multiple: false, label: 'productName'}"
                                               aria-placeholder="نام کالا/خدمات"
                                               @onChange="onproductInquiryChange"></vs-select>
                                </div>
                            </div>

                            <div class="col-lg-3 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">واحد کالا</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="units"
                                               :mode="'create'"
                                               :selected-val="selectedUnit"
                                               :header="{multiple: false, label: 'unitName'}"
                                               aria-placeholder="واحد کالا"
                                               @onChange="onUnitChange"></vs-select>
                                </div>
                            </div>

                            <div class="col-lg-3 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تعداد/وزن</span>
                                    </div>
                                    <input type="number" class="form-control" v-model="productCount">
                                </div>
                            </div>
                            <div class="col-lg-3 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نیاز به نمونه</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="ensamples"
                                               :mode="'create'"
                                               :selected-val="selectedSample"
                                               :header="{multiple: false, label: 'title'}"
                                               aria-placeholder="نیاز به نمونه"
                                               @onChange="onSampleChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">توضیحات</span>
                                    </div>
                                    <input class="form-control" v-model="descriptionOnSite">
                                </div>
                            </div>
                            <td class="text-center text-nowrap">
                                <i class="fa fa-trash-o px-3 clickable"
                                   style="font-size: larger"
                                   @click="deleteProduct(it)"
                                   title="حذف آیتم"></i>
                                |
                                <button class="btn btn-link text-accent-light"
                                        @click="onAddProductClicked()"><i class="fa fa-plus"></i>
                                </button>
                            </td>

                            <div class="col-12 overflow-5 m-3 pb-3" style="max-height: 12rem;">
                                <table class="table table-hover table-striped mb-3 ">

                                    <thead>
                                    <tr>
                                        <th>نام کالا</th>
                                        <th>واحد</th>
                                        <th>تعداد/وزن</th>
                                        <th>نیاز به نمونه</th>
                                        <th>توضیحات</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr v-for="it in productsInquiry" v-if="it.productCount>0">

                                        <td> {{it.productName}}</td>
                                        <td>{{it.unitName}}</td>
                                        <td>{{it.productCount}}</td>
                                        <td>{{showValueNeedSample(it.needSample)}}</td>
                                        <td>{{it.descriptionOnSite}}</td>
                                        <td class="text-center text-nowrap"><i
                                                class="fa fa-pencil-square-o px-3 clickable"
                                                style="font-size: larger"
                                                @click="editItemProduct(it)"
                                                title="ویرایش آیتم"></i>
                                            | <i class="fa fa-trash-o px-3 clickable"
                                                 style="font-size: larger"
                                                 @click="deleteItemProduct(it)"
                                                 title="حذف آیتم"></i>
                                        </td>

                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                        <div class="col-lg-6 offset-lg-3 text-center">
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="updateInquiry" v-if="inquiriMode==='edit'">ویرایش استعلام
                            </button>
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="createInquiry" v-else>ثبت استعلام
                            </button>
                            <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                    @click="cancelInquiry">انصراف
                            </button>
                        </div>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";

    export default {
        name: "inquiris",
        components: {VsSelect, DatePicker},
        data() {
            return {

                isLoading: true,
                inquiriMode: "",
                inquiriModel: {
                    userId: "",
                    createdate: "",
                    inquiriType: "",
                    inquirynumber: "",
                    registrationDate: "",
                    customerId: "",
                    startDate: "",
                    startHour: "",
                    expiryDate: "",
                    expiryHour: "",
                    settlementPeriod: "",
                    employeeId: "",
                    guaranteeAmount: 0,
                    inquiryStatus: "",
                    rank :0,
                    actualShippingCost:0,
                    shippingCostEstimate:0,
                    productWeight:0

                },
                displayexpiryHour: "",
                displaystartHour: "",
                displaytimecheck :"",
                timecheck :"",
                inquirisList: [],
                inquiryId: "",
                inquirydate: "",
                inquiryStartdate: "",
                inquiryEnddate: "",
                maxtime: 2400,
                fromhour: 0,
                tohour: 0,
                eninquiriType: [],
                selectedinquiriType: [],
                inquiriType: "",
                fullName: "",

                products: [{
                    inquiryId: "",
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                    samplevalue: "",
                    row: ""
                }],
                selectedproduct: {},
                selectedinquiryproduct: [],
                productsInquiry: [{
                    inquiryId: "",
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                    samplevalue: "",
                    row: ""
                }],
                productarrayMode: "",
                productMode: "",
                productModel: {
                    inquiryId: "",
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                    samplevalue: "",
                    row: ""
                },
                productInquiryModel: {

                    inquiryId: "",
                    productId: "",
                    unitId: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                    row: 0,
                },
                productInquiryModelSend: [],
                productinquirisList: [],
                productName: "",
                productCode: "",
                unitId: "",
                unitName: "",
                selectedUnit: [],
                productCount: "",
                descriptionOnSite: "",
                needSample: "",
                sampletitle: "",
                units: [],
                selectedUnits: "",
                selectedSample: "",
                samplevalue: "",
                ensamples: [],
                sampleid: "",
                rows: 0,
                checksaveok: false,
                inquirystatuslist: [],
                filtercustomer:"",
                customers2: [{
                    address: "",
                    birthday: "",
                    companyId: "",
                    createOn: "",
                    customerCode: "",
                    customerType: "",
                    email: "",
                    endCorporation: "",
                    family: "",
                    fatherName: "",

                    fullName: "",
                    id: "",
                    mobile: "",
                    name: "",
                    nationalCode: "",
                    phone: "",
                    postalCode: "",
                    taxCode: "",
                }],

                search: "",
                ///////////////////////////////////////////////////////////////
                ////////// old var                              ///////////////
                ///////////////////////////////////////////////////////////////

                showMyRegister : false,
                showArchive: false,
                showReciveDate: false,
                isSending: false,
                mycustomer: [],

                ////////////////////// End  Old var/////////////////////////////////
                ////////////////////// Daily Reports Parameter /////////////////////////////////
                dailyReportModel: {
                    id: 0,
                    description: "",
                    day : "",
                    fromTime : "",
                    toTime : "",
                    totalWork : "",
                    titleWorkId : "",
                    bossId :"",
                    bossApprovalDate : "",
                    managerId : "",
                    managerApprovalDate: "",
                    companyId: 0,
                    managerDescription :"",
                    bossDescription :"",
                },
                dateObj :"",
                currentDate :"",
                hFrom :"",
                mFrom :"",
                hTo :"",
                mTo :"",
                totaltime:"",
                hourTotal:"",
                minuteTotal:"",
                displaytotalWork :"",
                dailyReportMode : "create" ,
                //////////////////////End  Daily Reports Parameter /////////////////////////////////
            }
        },
        mounted() {


            this.getunits();
            this.getenSample();
            this.getEnInquiriType();
            this.getInquiryStatus();

            this.getInquirisList();

            this.getproducts();
            this.getcustomers();
            this.getcustomers2();
            //this.getProductInquiry();
        },
        methods: {

            getInquiryStatus() {
                new BaseService("enum", "/GetEnInquiriStatus").getList().then(response => {
                    this.inquirystatuslist = response.data;
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                });

            },
            setInquiryStatusName() {
                if (this.inquirisList && this.inquirystatuslist) {
                    for (let lis of this.inquirisList) {
                        for (let res of this.inquirystatuslist) {
                            if (lis.inquiryStatus === res.value) {
                                lis.inquiryStatusName = res.title;
                            }
                        }

                    }
                }
            },

            createdailyReport() {


                this.hTo = this.dailyReportModel.toTime.toString().substr(11, 2);
                this.mTo = this.dailyReportModel.toTime.toString().substr(14, 2);
                this.totaltime = parseInt(this.hTo) * 60 + parseInt(this.mTo) + 1
                    - parseInt(this.hFrom) * 60 - parseInt(this.mFrom);
                this.dailyReportModel.totalWork = this.totaltime;
                this.dailyReportModel.day = this.jalaliToGregorian(this.dailyReportModel.day);
                this.dailyReportModel.fromTime = this.jalaliToGregorian(this.dailyReportModel.fromTime);
                this.dailyReportModel.toTime = this.jalaliToGregorian(this.dailyReportModel.toTime);
                this.dailyReportModel.titleWorkId = 4;
                if(this.dailyReportMode==="create")
                {
                    if(this.inquirisList.fullName.length>0) {
                        this.dailyReportModel.description = "ثبت استعلام - " + this.inquirisList.fullName;
                    }
                    else if(this.filtercustomer.length>0) {
                        this.dailyReportModel.description = "ثبت استعلام - " + this.filtercustomer;
                    }
                }
                else {
                    this.dailyReportModel.description = "ویرایش استعلام - " + this.filtercustomer ;
                }

                let rec = 0;
                for (let pr of this.productsInquiry) {
                    rec++;
                    this.dailyReportModel.description = this.dailyReportModel.description + "  - "+ pr.productName + " - " + pr.productCount;
                    if (rec > 3) break;
                }

                new BaseService("dailyReports", "/CreatedailyReports").create(this.dailyReportModel).then(response => {
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });

            },

            createInquiry() {
                this.isSending = true;
                if(this.inquiriModel.inquirynumber=="" ){
                    Utils.handleErrorWithNotification("شماره استعلام را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if (this.inquirydate == "") {
                    Utils.handleErrorWithNotification("تاریخ استعلام را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if(this.selectedinquiriType=="") {
                    Utils.handleErrorWithNotification("نوع استعلام را انتخاب کنید", this.$noty);
                    this.isSending = false;
                } else if (this.inquiriModel.customerId == 0) {
                    Utils.handleErrorWithNotification("یک مشتری انتخاب کنید", this.$noty);
                    this.isSending = false;
                } else if(this.inquiryStartdate == "") {
                    Utils.handleErrorWithNotification("تاریخ شروع استعلام را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if(this.inquiriModel.startHour == "" ) {
                    Utils.handleErrorWithNotification("ساعت شروع استعلام را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if(this.inquiryEnddate == "" ) {
                    Utils.handleErrorWithNotification("تاریخ پایان استعلام را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if(this.inquiriModel.expiryHour == ""){
                    Utils.handleErrorWithNotification("ساعت پایان استعلام را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if(this.inquiriModel.settlementPeriod == ""){
                    Utils.handleErrorWithNotification("مدت تسویه را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if(this.inquiriModel.startDate >this.inquiriModel.expiryDate ){
                    Utils.handleErrorWithNotification("تاریخ پایان استعلام قبل از تاریخ شروع استعلام است", this.$noty);
                    this.isSending = false;
                } else if(this.inquiriModel.productWeight ==0 ){
                    Utils.handleErrorWithNotification("لطفا وزن تقریبی کالاهی استعلام را مشخص نمائید", this.$noty);
                    this.isSending = false;
                } else {

                    this.inquiriModel.inquiryStatus = 1;
                    this.inquiriModel.createdate = this.inquiriModel.registrationDate;

                    this.dateObj = new Date().toJSON();
                    this.currentDate = this.gregorianToJalali(this.dateObj, false);
                    this.dailyReportModel.toTime = Moment(this.currentDate).format('YYYY/MM/DD HH:mm');

                    new BaseService("inquiry", "/CreateInquirys").create(this.inquiriModel).then(response => {
                        this.inquiryId = response.data;
                        this.addInquiryProducts();
                        this.$noty.success("نیاز با موفقیت ثبت شد");

                        this.getInquirisList();
                        this.isSending = false;
                        this.$refs.insertModal.hideModal();

                    }).catch(error => {
                        this.isSending = false;

                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                    });
                    this.createdailyReport();
                }
            },
            addInquiryProducts() {
                var productsInquiryList = [];
                this.isSending = true;
                for (let pr of this.productsInquiry ) {
                    if(pr.productId>=0 && pr.productCount>0 && pr.productName!=="") {
                        if (pr.samplevalue === 0) {
                            this.needSample = 0;
                        } else {
                            this.needSample = 1;
                        }

                        this.productInquiryModel.inquiryId = this.inquiryId;
                        this.productInquiryModel.productId = pr.productId;
                        this.productInquiryModel.unitId = pr.unitId;
                        this.productInquiryModel.productCount = pr.productCount;
                        this.productInquiryModel.needSample = this.needSample;
                        this.productInquiryModel.descriptionOnSite = pr.descriptionOnSite;
                        this.productInquiryModel.row = pr.row;

                        productsInquiryList.push(this.productInquiryModel);
                        this.productInquiryModel = {

                            inquiryId: "",
                            productId: "",
                            unitId: "",
                            productCount: "",
                            descriptionOnSite: "",
                            needSample: "",
                            row: 0,
                        };

                    }
                    else {

                    }
                }
                if(productsInquiryList.length>0) {

                    var model = {
                        inquiryProductlist: productsInquiryList
                    };

                    new BaseService("InquiryProduct", "/CreateInquiryProductsList").create(model).then(response => {
                        //
                        this.isSending = false;

                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                    });
                }
            },
            getenSample() {
                new BaseService("enum", "/GetEnHaveNoHave").getList().then(response => {
                    if (response.data.length > 0) {
                        this.ensamples = response.data;

                    }


                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            onSampleChange(val) {
                if (val) {

                    this.selectedSample = val;

                }

            },
            onAddProductClicked() {

                let isadd = true;
                if(this.selectedSample === "دارد" || this.selectedSample.title === "دارد") {
                    this.needSample = true;
                }
                else {
                    this.needSample = false;
                }

                if (this.productarrayMode === "create") {

                    for (let prodinq of this.productsInquiry) {

                        if (prodinq.productName === this.productName) {
                            this.$noty.error('این کالا قبلا در لیست کالا ها اضافه شده است');
                            isadd = false;
                        }
                    }
                    if (isadd) {
                        this.rows = parseInt(this.rows + 1);
                        this.productsInquiry.push({
                            productId: this.productId,
                            productName: this.productName,
                            productCode: this.productCode,
                            unitId: this.unitId,
                            unitName: this.unitName,
                            productCount: this.productCount,
                            descriptionOnSite: this.descriptionOnSite,
                            needSample: this.needSample,
                            row: this.rows
                        });
                    }
                }
                if (this.productarrayMode === "edit") {
                    for (let prodinq of this.productsInquiry) {

                        if (prodinq.productName === this.productName && prodinq.row !== this.rows) {

                            this.$noty.error('این کالا قبلا در لیست کالا ها اضافه شده است');
                            isadd = false;
                        }
                    }
                    if (isadd) {
                        let id = 0;
                        for (let prodinq of this.productsInquiry) {

                            if (prodinq.row === this.rows) {
                                prodinq.productId = this.productId;
                                prodinq.productName = this.productName;
                                prodinq.productCode = this.productCode;
                                prodinq.unitId = this.unitId;
                                prodinq.unitName = this.unitName;
                                prodinq.productCount = this.productCount;
                                prodinq.descriptionOnSite = this.descriptionOnSite;
                                prodinq.needSample = this.needSample;


                                break;
                            }
                            id++;
                        }
                    }
                }

                if (isadd) {
                    this.productId = "";
                    this.productName = "";
                    this.productCode = "";
                    this.unitId = "";
                    this.unitName = "";
                    this.productCount = "";
                    this.descriptionOnSite = "";

                    this.needSample = "";
                    this.sampletitle = "";
                    this.selectedUnit = "";
                    this.selectedinquiryproduct = "";
                    this.selectedSample = "";
                }


            },
            getEnInquiriType() {
                new BaseService("enum", "/GetEnInquiriType").getList().then(response => {
                    this.eninquiriType = response.data;

                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            onInquiriTypeChange(val) {

                this.selectedinquiriType = val;
                this.title = val.title;
                this.inquiriModel.inquiriType = val.value;


            },


            getunits() {
                new BaseService("unit", "/Getunit").getList().then(response => {
                    if (response.data.length > 0) {
                        this.units = response.data;
                    }

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getproducts() {
                new BaseService("product", "/Getproduct").getList().then(response => {
                    this.products = response.data;

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            onChangeToTime() {
                this.inquiriModel.expiryHour = this.CheckTime(this.inquiriModel.expiryHour);


            },
            onChangesettlement() {
                if (parseInt(this.inquiriModel.settlementPeriod) > 160) {
                    this.$noty.error("مدت تسویه خیلی زیاد است");
                }
            },
            onChangestartHour() {
                this.inquiriModel.startHour = this.checkTime(this.inquiriModel.startHour);
                this.displaystartHour =this.setDisplayTime(this.inquiriModel.startHour);
            },
            onChangeexpiryHour() {
                this.inquiriModel.expiryHour = this.checkTime(this.inquiriModel.expiryHour);
                this.displayexpiryHour =this.setDisplayTime(this.inquiriModel.expiryHour);
            },
            checkTime(val) {
                this.timecheck = val;
                if(parseInt(this.timecheck)>this.maxtime)
                {
                    if(parseInt(this.timecheck.toString().substr(0,2))>=24)
                    {
                        this.timecheck=this.maxtime;
                    }
                    else if(parseInt(this.timecheck.toString().substr(4,2))>=60)
                    {

                        this.timecheck =val.toString().substr(0,2)+"59";
                    }
                    else
                    {
                        this.timecheck = this.timecheck.toString().substr(0, 4);

                    }
                }
                else
                {

                    if(this.timecheck.toString().length>3 )
                    {
                        if( parseInt(this.timecheck.toString().substr(2,2))>=60) {

                            this.timecheck = this.timecheck.toString().substr(0, 2) + "59";
                        }
                    }

                }
                return( this.timecheck);
            },
            setDisplayTime(val){
                let amount = val;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {

                    this.displaytimecheck = amount.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ":");
                    if(parseInt(amount)<1000)
                    {
                        this.displaytimecheck = "0"+parseInt(amount).toString().replace(/\B(?=(\d{2})+(?!\d))/g, ":");
                    }
                } else {
                    this.displaytimecheck = amount;
                }
                return(this.displaytimecheck);
            },
            showDateDayWork(val) {
                if (val) {
                    return (this.gregorianToJalaliBeautified(val, false));
                }
            },
            showExpiryHour(val){
                if (val) {
                    if (val.toString().length === 4) {
                        return (val.toString().substr(0, 2) + ":" + val.toString().substr(3, 2));
                    } else if (val.toString().length === 3) {
                        return (val.toString().substr(0, 2) + ":" + val.toString().substr(2, 1)+"0");

                    } else if (val.toString().length === 2) {
                        return (val.toString().substr(0, 2) + ":00");
                    }
                    else if (val.toString().length === 1) {
                        return ("0"+val.toString().substr(0, 1) + ":00");
                    }
                }
            },
            onMyRegistrationRecordClicked(){
                if (this.showMyRegister) {
                    this.showMyRegister = false;
                    this.getInquirisList();
                } else {
                    this.showMyRegister = true;
                    var status=2;
                    new BaseService("Inquiry", `/GetUserInquirysByStatus/${status}`).getList().then(response => {
                        this.inquirisList = response.data;
                        this.setInquiryStatusName();
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                    });

                }
            },
            onArchiveClicked() {
                if (this.showArchive) {
                    this.showArchive = false;
                    this.getInquirisList();
                } else {
                    this.showArchive = true;
                    var status=2;
                    new BaseService("Inquiry", `/GetInquirysByStatus/${status}`).getList().then(response => {
                        this.inquirisList = response.data;
                        this.setInquiryStatusName();
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                    });

                }
            },

            showstatusinquiry(val) {
                let result="";
                if (val && this.inquirystatuslist) {

                    for (let res of this.inquirystatuslist) {
                        if (parseInt(val) === parseInt(res.value) || parseInt(val.inquiryStatus) === parseInt(res.value)) {
                            result = res.title;
                            break;
                        }

                    }
                }
                return(result);
            },

            getcustomers() {
                new BaseService("customer", "/Getcustomer").getList().then(response => {
                    this.customers = response.data;


                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getcustomers2() {
                new BaseService("customer", "/Getcustomer").getList().then(response => {
                    this.customers2 = response.data;


                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            onAddInquiriClicked() {

                this.dailyReportModel = {
                    id: 0,
                    description: "",
                    day: "",
                    fromTime: "",
                    toTime: "",
                    totalWork: "",
                    titleWorkId: "",
                    bossId: "",
                    bossApprovalDate: "",
                    managerId: "",
                    managerApprovalDate: "",
                    companyId: 0,
                    managerDescription :"",
                    bossDescription :"",
                    managerConfirm:0,
                    bossConfirm:0,
                };
                this.dailyReportMode="create";
                this.dateObj = new Date().toJSON();
                this.currentDate = this.gregorianToJalali(this.dateObj, false);
                this.dailyReportModel.day= Moment(this.currentDate).format('YYYY/MM/DD HH:mm');
                this.dailyReportModel.fromTime = Moment(this.currentDate).format('YYYY/MM/DD HH:mm');
                this.hFrom = this.dailyReportModel.fromTime.toString().substr(11,2);
                this.mFrom =  this.dailyReportModel.fromTime.toString().substr(14,2);


                this.inquiriMode = "create";
                this.inquiriModel = {
                    userId: "",
                    createdate: "",
                    inquiriType: "",
                    inquirynumber: "",
                    registrationDate: "",
                    customerId: "",
                    startDate: "",
                    startHour: "",
                    expiryDate: "",
                    expiryHour: "",
                    settlementPeriod: "",
                    employeeId: "",
                    guaranteeAmount: 0,
                    inquiryStatus: "",
                    rank :0,
                    actualShippingCost:0,
                    shippingCostEstimate:0,
                    productWeight:0
                };
                this.productMode = "";
                this.productModel = {
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                };
                this.productsInquiry= [{
                    inquiryId: "",
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                    samplevalue: "",
                    row: ""
                }],
                this.productName = "";
                this.productCode = "";
                this.unitId = "";
                this.unitName = "";
                this.productCount = "";
                this.descriptionOnSite = "";
                this.needSample = "";
                this.inquirydate = "";
                this.inquiryStartdate = "";
                this.fromhour = "";
                this.tohour = "";
                this.inquiryEnddate = "";
                this.filtercustomer = "";
                this.displayexpiryHour="";
                this.displaystartHour="";
                this.inquiriMode = "create";
                this.productarrayMode = "create";

                this.$refs.insertModal.showModal();
            },
            showValueNeedSample(val) {

                if (val === 0 || val === true || val === "دارد") {
                    return ("دارد");
                }
                else {
                    return ("ندارد");
                }

            },

            getInquirisList() {
                var status=1;
                new BaseService("Inquiry", `/GetInquirysByStatus/${status}`).getList().then(response => {
                    this.inquirisList = response.data;

                    this.setInquiryStatusName();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                });

            },
            editItemProduct(item) {

                this.productName = item.productName;
                this.unitName = item.unitName;
                this.unitId = item.unitId;
                this.productCount = item.productCount;
                this.needSample = item.needSample;
                this.descriptionOnSite = item.descriptionOnSite;
                this.productId = item.productId;
                this.selectedinquiryproduct = item.productName;
                this.selectedproduct = item.productName;
                this.selectedUnit = item.unitName;
                if (item.needSample === true) {
                    this.samplevalue = true;
                    this.selectedSample = "دارد";
                    this.sampletitle = "دارد";
                }
                else {
                    this.samplevalue = false;
                    this.selectedSample = "ندارد";
                    this.sampletitle = "ندارد";
                }
                this.rows = item.row;

                this.sampleid = item.sampleid;
                this.needSample = item.sampleid;


                this.productarrayMode = "edit";
            },
            editInquiryItem(item) {

                this.dailyReportModel = {
                    id: 0,
                    description: "",
                    day: "",
                    fromTime: "",
                    toTime: "",
                    totalWork: "",
                    titleWorkId: "",
                    bossId: "",
                    bossApprovalDate: "",
                    managerId: "",
                    managerApprovalDate: "",
                    companyId: 0,
                    managerDescription :"",
                    bossDescription :"",
                    managerConfirm:0,
                    bossConfirm:0,
                };
                this.dateObj = new Date().toJSON();
                this.currentDate = this.gregorianToJalali(this.dateObj, false);
                this.dailyReportModel.day= Moment(this.currentDate).format('YYYY/MM/DD HH:mm');
                this.dailyReportModel.fromTime = Moment(this.currentDate).format('YYYY/MM/DD HH:mm');
                this.hFrom = this.dailyReportModel.fromTime.toString().substr(11,2);
                this.mFrom =  this.dailyReportModel.fromTime.toString().substr(14,2);
                this.dailyReportMode="edit";

                this.inquiriModel = item;

                this.inquiryId = item.id;
                this.productarrayMode = "create";
                this.inquiriMode = "edit";
                for (let it of this.eninquiriType) {
                    if (it.value === item.inquiriType) {
                        this.selectedinquiriType = it.title;
                        break;
                    }
                }
                this.filtercustomer = item.customerFullName;
                if (item.registrationDate != null) {
                    this.inquirydate = Moment(this.gregorianToJalali(item.registrationDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                if (item.startDate != null) {
                    this.inquiryStartdate = Moment(this.gregorianToJalali(item.startDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                if (item.expiryDate != null) {
                    this.inquiryEnddate = Moment(this.gregorianToJalali(item.expiryDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                this.onChangestartHour();
                this.onChangeexpiryHour();
                new BaseService("InquiryProduct", `/GetInquiryProducts/${item.id}`).getList().then(response => {
                    this.productsInquiry = response.data;
                    this.isLoading = true;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });

                this.$refs.insertModal.showModal();
            },
            deleteInquiryItem(item) {
                this.isSending = true;
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {


                    new BaseService("Inquiry", "DeleteInquirys").delete(item.id).then(response => {
                        Utils.handleErrorWithNotification("این استعلام با موفقیت حذف شد", this.$noty);
                        this.isSending = false;
                        this.getInquirisList();

                    }).catch(error => {
                        Utils.handleErrorWithNotification("این آیتم در جای دیگری استفاده شده است، ابتدا موارد وابسته ( کالاها، استعلام قیمت از تامین کننده ) را حذف کنید", this.$noty);
                    })


                }
            },
            updateInquiry() {
                this.isSending = true;
                if(this.inquiriModel.inquirynumber==="" ){
                    Utils.handleErrorWithNotification("شماره استعلام را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if (this.inquirydate === "") {
                    Utils.handleErrorWithNotification("تاریخ استعلام را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if(this.selectedinquiriType==="") {
                    Utils.handleErrorWithNotification("نوع استعلام را انتخاب کنید", this.$noty);
                    this.isSending = false;
                } else if (this.inquiriModel.customerId === 0) {
                    Utils.handleErrorWithNotification("یک مشتری انتخاب کنید", this.$noty);
                    this.isSending = false;
                } else if(this.inquiryStartdate === "") {
                    Utils.handleErrorWithNotification("تاریخ شروع استعلام را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if(this.inquiriModel.startHour === "" ) {
                    Utils.handleErrorWithNotification("ساعت شروع استعلام را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if(this.inquiryEnddate === "" ) {
                    Utils.handleErrorWithNotification("تاریخ پایان استعلام را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if(this.inquiriModel.expiryHour === ""){
                    Utils.handleErrorWithNotification("ساعت پایان استعلام را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if(this.inquiriModel.settlementPeriod === ""){
                    Utils.handleErrorWithNotification("مدت تسویه را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if(this.inquiriModel.startDate >this.inquiriModel.expiryDate){

                    Utils.handleErrorWithNotification("تاریخ پایان استعلام قبل از تاریخ شروع استعلام است", this.$noty);
                    this.isSending = false;
                } else if(this.inquiriModel.productWeight ==0 ){
                    Utils.handleErrorWithNotification("لطفا وزن تقریبی کالاهی استعلام را مشخص نمائید", this.$noty);
                    this.isSending = false;
                } else {

                    if (this.inquiriModel && this.eninquiriType) {
                        for (let lis of this.eninquiriType) {
                            if (this.selectedinquiriType === lis.title) {
                                this.inquiriModel.inquiriType = lis.value;
                                break;
                            }
                        }
                    }

                    if (this.inquiryId != null) {
                        this.deleteProductInquiry(this.inquiryId);
                    }
                    this.dateObj = new Date().toJSON();
                    this.currentDate = this.gregorianToJalali(this.dateObj, false);
                    this.dailyReportModel.toTime = Moment(this.currentDate).format('YYYY/MM/DD HH:mm');

                    new BaseService("inquiry", "/UpdateInquirys").update(this.inquiriModel).then(response => {

                        this.$noty.success("استعلام با موفقیت ویرایش شد");
                        this.getInquirisList();

                        this.$refs.insertModal.hideModal();
                        this.isSending = false;

                    }).catch(error => {
                        this.isSending = true;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                        this.getInquirisList();
                    });
                    this.createdailyReport();
                }
            },
            deleteProductInquiry(val) {
                this.isSending = true;
                new BaseService("inquiryProduct", "/DeleteInquiryProducts").delete(val).then(response => {
                    this.addInquiryProducts();
                    this.isSending = false;
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getInquirisList();
                });
            },
            deleteItemProduct(val) {
                this.isSending = true;
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    let bla = this.productsInquiry.find((stack) => {
                        return stack.id === val.id;
                    });
                    this.productsInquiry.splice(bla, 1);

                    //this.productsInquiry.$remove(val.id)


//                this.$delete(this.productsInquiry, val)
                    this.productName = "";
                    this.productId = "";
                    this.unitName = "";
                    this.unitId = "";
                    this.descriptionOnSite = "";
                    this.productCount = 0;
                    this.productCode = "";
                    this.selectedSample = "";
                    this.selectedUnits = "";
                    this.selectedUnit = "";
                    this.selectedproduct = "";
                    this.productModel.inquiryId = "";
                    this.productModel.productId = "";
                    this.productModel.productName = "";
                    this.productModel.productCode = "";
                    this.productModel.unitId = "";
                    this.productModel.unitName = "";
                    this.productModel.productCount = "";
                    this.productModel.descriptionOnSite = "";
                    this.productModel.needSample = "";
                    this.productModel.samplevalue = "";
                    this.productarrayMode = "create";
                }
                this.isSending = false;
            },
            deleteProduct() {
                this.productName = "";
                this.productId = "";
                this.unitName = "";
                this.unitId = "";
                this.descriptionOnSite = "";
                this.productCount = 0;
                this.productCode = "";
                this.selectedSample = "";
                this.selectedUnits = "";
                this.selectedUnit = "";
                this.selectedproduct = "";
            }
            ,

            cancelInquiry() {
                this.$refs.insertModal.hideModal();
            }
            ,


            onCreateInquiryDatePicked(val) {
                this.inquirydate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.inquiriModel.registrationDate = this.jalaliToGregorian(val);
            }
            ,
            toggleCreateInquiryDatePicker() {
                this.$refs.inquirydate.togglePicker();
            }
            ,
            onStartDatePicked(val) {

                this.inquiryStartdate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.inquiriModel.startDate = this.jalaliToGregorian(val);

            }
            ,
            toggleStartDatePicker() {
                this.$refs.inquiryStartdate.togglePicker();
            }
            ,
            onEndDatePicked(val) {
                this.inquiryEnddate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.inquiriModel.expiryDate = this.jalaliToGregorian(val);
            }
            ,
            toggleEndDatePicker() {
                this.$refs.inquiryEnddate.togglePicker();
            }
            ,
            searching() {
                if (this.search.length >=2) {

                    // this.isLoading = false;
                    new BaseService("inquiry", `/SearchInquirys/${this.search}`).getList().then(response => {
                        if(response.data.length>0){
                        this.inquirisList = response.data;
                        this.setInquiryStatusName();

                        }
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },

            selectItem(it) {
                if (it && it.productName) {
                    this.productName = it.productName;
                    this.unitId = it.unitId;
                    this.unitName = it.unitName;
                    this.productCount = it.productCount;
                    this.productId = it.productId;
                    this.descriptionOnSite = it.descriptionOnSite;
                    this.needSample = it.needSample;
                }

            },
            onUnitChange(val) {
                if (val && val.unitName) {
                    this.unitName = val.unitName;
                    this.unitId = val.unitValue;
                    this.selectedUnit = val;

                }
            }
            ,
            onproductInquiryChange(val) {

                if (val && val.productName) {
                    this.selectedinquiryproduct = val;
                    this.productId = val.id;
                    this.productName = val.productName;

                }
            }
            ,
            onfiltercustomerInquiryChange(val) {
                if (val && val.fullName != null) {
                    this.filtercustomer = val;
                    this.inquiriModel.customerId = val.id;
                }
            },
        },

    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>